export default function updateAction(state, payload) {
  return {
    ...state,
    organizacija: {
      ...state.organizacija,
      ...payload,
    },
  };
}
